<template>
  <div class="tusd-wrap wrap-image login-register">
  	<div class="return-btn" @click="goBack"></div>
    <div class="login-register-header">
    	<p>找回密码</p>
    </div>
    <div class="account-wrap">
    	<div class="wrap-item">
    		<span class="item-label phone-label">邮箱： </span>
    		<span class="unit send-code" @click="sendCode">{{sendTxt}}</span>
    		<input type="text"   v-model="register.Email" placeholder="请输入邮箱" />
    	</div>
    	<div class="wrap-item">
    		<span class="item-label verify-label">验证码： </span>
    		<input type="text" v-model="register.code" placeholder="请输入验证码" />
    	</div>
    	<div class="wrap-item">
    		<span class="item-label reset-label">新密码： </span>
    		<input type="text" maxlength="20" v-model="register.password" placeholder="请输入您的新密码" />
    	</div>
    	<div class="wrap-item">
    		<span class="item-label reset-label">确认密码： </span>
    		<input type="text" maxlength="20" v-model="register.rePassword" placeholder="请确认您的新密码" />
    	</div>
    	<div class="tusd-btn login-register-btn" @click="findPwd">找回</div>
		<div class="copyright">Copyright © {{year}} Company. All rights reserved.</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'forgot',
  data(){
  	return {
		year:new Date().getFullYear(),
  		register:{
  			Email:'',
  			code:'',
			password:'',
			rePassword:'',
			AccoutType:_ACCOUNTTYPY_,
        	SmsType:2
		  },
		confirmPw:'',
		hasClick:false,
		send:false,
		sendTxt:'验证码',
		params:{},
  	}
  },
  methods:{
  	goBack(){
  		this.$router.push({name:this.params.back})
	  },
	  sendCode(){
		let that=this;
  		if(that.send){
			return false;
  		}
  		if(!that.register.Email){
			that.$message.popup("请输入邮箱",1000);
  			return false
  		}
  		// if(!that.verify.verifyPhone(that.register.phone)){
		// 	that.$message.popup("请输入正确的手机号",1000);
  		// 	return false
		//   }
		let data={
  			Email:that.register.Email,
  			AccoutType:_ACCOUNTTYPY_,
        	SmsType:2
  		};
		that.$api.sendEmailCode(data).then((res)=>{
		        that.$message.popup("发送成功",1000);
				that.send = true
  				that.common.countdown(that.$store.state.sendTime,that,'sendTxt',() => {
					that.send=false;
  					that.sendTxt = '验证码'
  				})
		});
	  },
	  	findPwd(){
			let that=this;
		 if(that.hasClick){
			 return false;
  		}
  		if(!that.register.Email){
			 that.$message.popup("请输入邮箱",1000);
  			return false
  		}
  		// if(!that.verify.verifyPhone(that.register.phone)){
		// 	that.$message.popup("请输入正确的手机号",1000);
  		// 	return false
  		// }
  		if(!that.register.code){
			that.$message.popup("请输入验证码",1000);
  			return false
  		}
  		if(!that.register.password){
			that.$message.popup("请输入您新密码",1000);
  			return false
  		}
  		if(!that.verify.verifyPassword(that.register.password)){
			that.$message.popup("密码6~20位数字、字母或字符",1000);
  			return false
  		}
  		if(that.register.password != that.register.rePassword){
			that.$message.popup("两次密码不一致",1000);
  			return false
		}
		that.$api.forgetPassword(this.register).then(res => {
				that.$message.popup("找回密码成功",1000)
				this.goBack()
			});
  	}
  },
  created(){
  	this.params = this.$store.state.routerStore.forgot
  }
}
</script>
<style lang="less" scoped>
	.login-register{
		padding:22% 6px 0px;
	}
	.phone-label,
	.verify-label{
		width: 92px!important;
	}
	.send-code + input{
				width: calc(100% - 136px)!important;
			}
</style>